import React, { useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import DataContext from '../context'; 
function LocationModal() {
    const contextValues = useContext(DataContext)
    const locationModal = () => {
        contextValues.setToggleLocationModal(!contextValues.toggleLocationModal)
    }
    return (
        <>
            <Modal className='loginModal' show={contextValues.toggleLocationModal} onHide={locationModal}>
                <button type='button' className='modal-close' onClick={() => { locationModal() }}><i className="ri-close-line"></i></button>
                <div className='loginModalContent'>
                    <div className='text-center'>
                        <h5>Location</h5>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default LocationModal;